import { SVGProps } from "react";

const Clover = ({ ...props }: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="153"
      height="153"
      viewBox="0 0 153 153"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M76.5 0C56.198 0 39.7403 16.4579 39.7403 36.7597C39.7403 38.4058 38.4058 39.7403 36.7597 39.7403C16.4579 39.7403 0 56.198 0 76.5C0 96.802 16.4579 113.26 36.7597 113.26C38.4058 113.26 39.7403 114.594 39.7403 116.24C39.7403 136.542 56.198 153 76.5 153C96.802 153 113.26 136.542 113.26 116.24C113.26 114.594 114.594 113.26 116.24 113.26C136.542 113.26 153 96.802 153 76.5C153 56.198 136.542 39.7403 116.24 39.7403C114.594 39.7403 113.26 38.4058 113.26 36.7597C113.26 16.4579 96.802 0 76.5 0Z"
        fill="#6FCF97"
      />
    </svg>
  );
};

export default Clover;
